import { Getter } from 'vuex'
import { UserState } from '../types'
import { RootState } from '@/store/types'

const isShowNotificationMobile: Getter<UserState, RootState> = (state) => {
  return state.showNotificationMobile
}

export default isShowNotificationMobile
